<div class="slider">
  <ul class="slider__wrapper" [style.transform]="'translateX(-' + currentSlide * 100 + '%)'">
    @for (slide of sliderData; track slide) {
      <li class="slide" [class.slide--current]="slide.index === currentSlide">
        <gcc-notification-item [notification]="slide" (delete)="handleDelete($event)"></gcc-notification-item>
      </li>
    }
  </ul>

  <div class="slider__controls">
    <button
      [disabled]="isFirstStepDisabled"
      class="btn btn--previous"
      title="Go to previous slide"
      (click)="onPreviousClick()"
    >
      <span class="icon-ic-arrow-left"></span>
    </button>

    <span>{{ currentSlide + 1 }}/{{ sliderData.length }}</span>

    <button [disabled]="isSecondStepDisabled" class="btn btn--next" title="Go to next slide" (click)="onNextClick()">
      <span class="icon-ic-arrow-right"></span>
    </button>
  </div>
</div>
